import { render, staticRenderFns } from "./LiveList.vue?vue&type=template&id=e20f26b6&scoped=true&"
import script from "./LiveList.vue?vue&type=script&lang=js&"
export * from "./LiveList.vue?vue&type=script&lang=js&"
import style0 from "./LiveList.vue?vue&type=style&index=0&id=e20f26b6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e20f26b6",
  null
  
)

export default component.exports